import type { IsPointInPolygon } from "./types";

// Ray casting with even-odd semantics: works for any polygon, including self-intersecting ones.
// Verbatim twin of nest_backend .../quantity-surveyor-selection-areas/helpers/isPointInPolygon — keep in sync.
export const isPointInPolygon: IsPointInPolygon = ({ point, ring }) => {
  let isInside = false;

  for (let i = 0, j = ring.length - 1; i < ring.length; j = i, i++) {
    const current = ring[i];
    const previous = ring[j];

    const currentSideOfRay = current.y > point.y;
    const previousSideOfRay = previous.y > point.y;
    const crossesRay = currentSideOfRay !== previousSideOfRay;
    if (!crossesRay) continue;

    const intersectionX =
      current.x +
      ((point.y - current.y) / (previous.y - current.y)) *
        (previous.x - current.x);

    if (point.x < intersectionX) isInside = !isInside;
  }

  return isInside;
};
